import { useState } from "react";

// Tickbox selection for DataTable rows, groups and the header.
export default function useSelection() {
  const [selectedIds, setSelectedIds] = useState(() => new Set());

  const toggleGroup = (ids, checked) =>
    setSelectedIds((prev) => {
      const next = new Set(prev);
      ids.forEach((id) => (checked ? next.add(id) : next.delete(id)));
      return next;
    });

  const toggleRow = (id) =>
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });

  const toggleAll = (ids, checked) => setSelectedIds(checked ? new Set(ids) : new Set());
  const clear = () => setSelectedIds(new Set());

  return { selectedIds, setSelectedIds, toggleRow, toggleGroup, toggleAll, clear };
}
